import { createFileRoute } from '@tanstack/react-router'
import { ProductionDashboard } from 'pages/productionDashboard/ProductionDashboard'

export const Route = createFileRoute(
  '/production-dashboard/$orgID/$siteID/$configID'
)({
  component: ProductionDashboardRouteComponent,
  staticData: {
    title: 'Production Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})

function ProductionDashboardRouteComponent() {
  const params = Route.useParams()
  return <ProductionDashboard {...params} />
}
